const COMPONENT_NAME = "sub-navigation";
const CSS_ACTIVE = "is-active";
const CSS_ANIMATED = "is-animated";
const CSS_OPEN = "is-open";
const CSS_COLLAPSED = "is-collapsed";
const CHILD_CLASS = "SubNavigationItem";
const VARIANT_BUTTON = CHILD_CLASS + "--button";
const VARIANT_DROPDOWN = CHILD_CLASS + "--dropdown";

const instances = [];
const handlers = {};
let index = 0;

function initialize(element, PageComponents) {
    const subNavWrapper = element.querySelector('.SubNavigation-wrapper');
    const subNavScroller = element.querySelector('.SubNavigation-scroller');
    const subNavContent = element.querySelector('.SubNavigation-content');
    const subNavUnderline = element.querySelector('.SubNavigation-underline');

    // Dropdown behavior
    const subNavDropdown = element.querySelector('.SubNavigationDropdown');
    function setDropdownLabel(setDefault = false) {
        const dropdownLabel = element.querySelector('.SubNavigationDropdown-label');
        const dropdownText = element.querySelector('.SubNavigationDropdown-text');

        if (dropdownLabel && dropdownText) {
            dropdownText.textContent = dropdownText.getAttribute('data-label');
            if (setDefault) {
                const labelTag = dropdownLabel.querySelector('.SubNavigationItem-tag');
                if (labelTag != null) {
                    dropdownLabel.removeChild(labelTag);
                }
                return;
            }
            const activeSelection = element.querySelector('.SubNavigationItem-link[data-value="' + dropdownText.getAttribute('data-value') + '"]');
            activeSelection.parentElement.classList.add(CSS_ACTIVE);
            const selectionTag = element.querySelector('.SubNavigationItem-tag[data-label="' + activeSelection.getAttribute('data-label') + '"]');
            if (selectionTag != null && !dropdownLabel.firstElementChild.classList.contains('SubNavigationItem-tag')) {
                dropdownLabel.insertBefore(selectionTag.cloneNode(true), dropdownLabel.lastElementChild);
                dropdownText.textContent = activeSelection.getAttribute('data-label');
            } else {
                dropdownText.textContent = activeSelection.textContent;
            }
        }
    }
    if (subNavDropdown != null) {
        setDropdownLabel();
    }

    // Sync nav with page section
    let pageSections = [];
    function checkActiveSection() {
        requestAnimationFrame(() => {
            const midpoint = window.innerHeight / 2;
            pageSections.forEach((token, index) => {
                const anchor = element.querySelector('.SubNavigationItem[data-target="' + token + '"]');
                const section = document.getElementById(token)?.getBoundingClientRect();
                if (anchor && section) {
                    let isActive;
                    if (index === 0) {
                        isActive = midpoint < section.bottom;
                    } else if (index === (pageSections.length - 1)) {
                        isActive = section.top < midpoint;
                    } else {
                        isActive = section.top < midpoint && midpoint < section.bottom;
                    }
                    if (isActive && !anchor.classList.contains(CSS_ACTIVE)) {
                        anchor.classList.add(CSS_ACTIVE);
                        moveSubNavUnderline(anchor);
                    } else {
                        anchor.classList.toggle(CSS_ACTIVE, isActive);
                    }
                }
            });
        });
    }

    function subNavScrollHandler() {
        checkActiveSection();
    }
    document.addEventListener("scroll", subNavScrollHandler);

    // Align underline on page sub-nav
    function moveSubNavUnderline(element, animate = true) {
        moveSubNavUnderlineTo(element.offsetLeft, element.offsetWidth, animate);
    }
    function moveSubNavUnderlineTo(left, width, animate = true) {
        subNavUnderline.classList.toggle(CSS_ANIMATED, animate);
        subNavUnderline.style.left = left + 'px';
        subNavUnderline.style.width = width + 'px';
    }

    let navAnchors = element.querySelectorAll('.SubNavigationItem');
    for (const el of navAnchors) {
        if (el.dataset.target && !pageSections.includes(el.dataset.target)) {
            pageSections.push(el.dataset.target);
        }
    }
    subNavScrollHandler();

    let activeSubNavItem = element.querySelector('.SubNavigationItem.is-active');
    if (activeSubNavItem) {
        moveSubNavUnderline(activeSubNavItem, false);
    }
    for (let i = 0; i < navAnchors.length; i++) {
        if (navAnchors[i].classList.contains(CSS_ACTIVE)) continue;
        if (navAnchors[i].classList.contains(VARIANT_BUTTON)) continue;
        if (navAnchors[i].classList.contains(VARIANT_DROPDOWN)) continue;

        navAnchors[i].addEventListener("mouseenter", function () {
            moveSubNavUnderline(navAnchors[i]);
        });
        navAnchors[i].addEventListener("mouseleave", function () {
            const activeElem = element.querySelector('.SubNavigationItem.is-active');
            if (activeElem) {
                moveSubNavUnderline(activeElem);
            }
        });
    }

    let resizeSubNavDebounce = null;
    function subNavResizeHandler() {
        const activeElem = element.querySelector('.SubNavigationItem.is-active');
        if (activeElem) {
            moveSubNavUnderline(activeElem, false);
        }

        if (resizeSubNavDebounce != null) {
            clearTimeout(resizeSubNavDebounce);
        }
        resizeSubNavDebounce = setTimeout(resizeSubNav, 50);
    }
    function resizeSubNav() {
        requestAnimationFrame(() => {
            const activeElem = element.querySelector('.SubNavigationItem.is-active');

            element.classList.remove(CSS_COLLAPSED);
            subNavContent.classList.remove(CSS_COLLAPSED);
            if (subNavDropdown) {
                subNavDropdown.classList.remove(CSS_COLLAPSED);
                subNavDropdown.querySelectorAll('.SubNavigationItem--dropdown').forEach((dropdownElement) => {
                    dropdownElement.classList.remove(CSS_COLLAPSED);
                });
            }
            if (subNavContent.offsetWidth > subNavWrapper.offsetWidth) {
                element.classList.add(CSS_COLLAPSED);
                subNavContent.classList.add(CSS_COLLAPSED);
                if (subNavDropdown) {
                    subNavDropdown.classList.add(CSS_COLLAPSED);
                    setDropdownLabel(true);
                    subNavDropdown.querySelectorAll('.SubNavigationItem--dropdown').forEach((dropdownElement) => {
                        dropdownElement.classList.add(CSS_COLLAPSED);
                    });
                }
            }
            subNavScrollHandler();
        });
    }
    window.addEventListener("resize", subNavResizeHandler);
    window.addEventListener("load", resizeSubNav);
    subNavResizeHandler();

    element.querySelector('.SubNavigation-down').addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        element.classList.toggle(CSS_OPEN);
        subNavContent.classList.toggle(CSS_OPEN);
        if (subNavDropdown) subNavDropdown.classList.toggle(CSS_OPEN);
        subNavResizeHandler();
    });

    handlers[index++] = {
        subNavWrapper,
        subNavScroller,
        subNavContent,
        subNavUnderline,
        moveSubNavUnderline,
        moveSubNavUnderlineTo,
        subNavResizeHandler,
        subNavScrollHandler,
    }
}
const SubNavigation = {
    name: COMPONENT_NAME,
    instances,
    handlers,
    initialize,
}

module.exports = SubNavigation;
